import { MPTable } from '@components';
import { useVisitorStatsTable } from './useVisitorStatsTable';
import styles from './styles.module.scss';

export function VisitorStatsTable({ id }: Props) {
    const { data, columns, isFetching } = useVisitorStatsTable(id);
    return (
        <>
            <MPTable
                dataSource={data}
                columns={columns}
                loading={isFetching}
                className={styles.VisitorStatsTable}
                scroll={{ x: 'auto' }}
                pagination={{ hideOnSinglePage: true }}
            />
        </>
    );
}

interface Props {
    id?: string;
}
